import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { api } from '../lib/api';

const TenantCtx = createContext(null);

export function TenantProvider({ children }) {
  const { token } = useAuth();
  const [profile, setProfile] = useState(null);
  const [branches, setBranches] = useState([]);
  const [region, setRegion] = useState(null);
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshProfile = useCallback(async () => {
    if (!token) return;
    try {
      const p = await api.tenantProfile(token);
      setProfile(p);
    } catch { /* silent */ }
  }, [token]);

  const refreshBranches = useCallback(async () => {
    if (!token) return;
    try {
      const res = await api.branchesList(token);
      setBranches(res.branches || res.items || []);
    } catch { /* silent */ }
  }, [token]);

  const refreshRegion = useCallback(async () => {
    if (!token) return;
    try {
      const r = await api.regionGet(token);
      setRegion(r);
    } catch { /* silent */ }
  }, [token]);

  const refreshBrand = useCallback(async () => {
    if (!token) return;
    try {
      const b = await api.brandLogoGet(token);
      setBrand(b);
    } catch { /* silent */ }
  }, [token]);

  useEffect(() => {
    if (!token) {
      setProfile(null);
      setBranches([]);
      setRegion(null);
      setBrand(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    Promise.all([refreshProfile(), refreshBranches(), refreshRegion(), refreshBrand()])
      .finally(() => setLoading(false));
  }, [token, refreshProfile, refreshBranches, refreshRegion, refreshBrand]);

  return (
    <TenantCtx.Provider value={{ profile, branches, region, brand, loading, refreshProfile, refreshBranches, refreshRegion, refreshBrand }}>
      {children}
    </TenantCtx.Provider>
  );
}

export function useTenant() {
  const ctx = useContext(TenantCtx);
  if (!ctx) throw new Error('useTenant must be inside TenantProvider');
  return ctx;
}
